import lrAIChatPanel from './_src/lrAIChatPanel.vue'

lrAIChatPanel.install = function(Vue) {
  Vue.component(lrAIChatPanel.name, lrAIChatPanel)
}

export default lrAIChatPanel